import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { NudgeNotification } from 'models/Notification';
import api from 'api';
import DislikeIcon from 'icons/Dislike.icon';
import LikeIcon from 'icons/Like.icon';
import ClockIcon from 'icons/Clock.icon';

import './NudgeBanner.styles.scss';
import './NudgeBanner.styles.responsive.scss';

type NudgeBannerProps = {
  className?: string;
  nudge: NudgeNotification;
  onClose: () => void;
};

const NudgeBanner: React.FC<NudgeBannerProps> = (props) => {
  const { className, nudge, onClose } = props;

  const fileName = nudge.dataRoomNodes?.[0]?.name;
  const listingName = nudge.listing?.listingTitle;

  const { t } = useTranslation();

  const classes = classNames('nudge-banner', className);

  const handleWithdraw = useCallback(() => {
    api.portfolio.buyer.withdrawInterest(nudge.leadId);
    onClose();
  }, [nudge, onClose]);

  const handleConfirmInterest = useCallback(() => {
    api.nudges.confirmInterest(nudge._id);
    onClose();
  }, [nudge, onClose]);

  const handleSnooze = useCallback(() => {
    api.nudges.snoozeNudgeNotification(nudge._id);
    onClose();
  }, [nudge, onClose]);

  return (
    <div className={classes}>
      <div>
        <p>{t('youveSeenThe', { fileName })}</p>
        <p>
          {t('stillInterestedInTheListing', {
            listingName,
          })}
        </p>
      </div>
      <Button variant="link" icon={DislikeIcon} onClick={handleWithdraw}>
        {t('notForMe')}
      </Button>
      <Button icon={LikeIcon} onClick={handleConfirmInterest}>
        {t('confirmInterest')}
      </Button>
      <Button
        variant="link"
        icon={ClockIcon}
        onClick={handleSnooze}
        className="snooze"
      >
        {t('snooze')}
      </Button>
    </div>
  );
};

export default NudgeBanner;
